import { create } from "zustand";
import { persist } from "zustand/middleware";

import {
  ChronologySortField,
  ChronologyViewType,
  SortDirection,
} from "../components/MedicalChronology/Visits/types";

interface UserCustomizationPreferencesState {
  collapseTherapyVisits: boolean;
  chronologyViewGroupBy: ChronologyViewType;
  chronologySortField: ChronologySortField;
  chronologySortDirection: SortDirection;
  visitsDisplayMode: "list" | "table";
  hiddenVisitTypeIds: string[];
  setCollapseTherapyVisits: (value: boolean) => void;
  setChronologyViewGroupBy: (value: ChronologyViewType) => void;
  setChronologySort: (field: ChronologySortField, direction: SortDirection) => void;
  setVisitsDisplayMode: (mode: "list" | "table") => void;
  setHiddenVisitTypeIds: (ids: string[]) => void;
}

export const useUserCustomizationPreferencesStore = create<UserCustomizationPreferencesState>()(
  persist(
    (set, get) => ({
      collapseTherapyVisits: true,
      chronologyViewGroupBy: ChronologyViewType.DATE,
      chronologySortField: ChronologySortField.DATE,
      chronologySortDirection: SortDirection.ASC,
      visitsDisplayMode: "list",
      hiddenVisitTypeIds: [],
      setCollapseTherapyVisits: (value) => set({ collapseTherapyVisits: value }),
      setChronologyViewGroupBy: (value) => {
        const currentField = get().chronologySortField;
        // Page sort only makes sense when grouped by Files, and Name sort only when
        // some grouping is active — fall back to date order otherwise.
        const shouldResetSort =
          (value !== ChronologyViewType.FILE && currentField === ChronologySortField.PAGE) ||
          (value === ChronologyViewType.DATE && currentField === ChronologySortField.NAME);
        set({
          chronologyViewGroupBy: value,
          ...(shouldResetSort
            ? {
                chronologySortField: ChronologySortField.DATE,
                chronologySortDirection: SortDirection.ASC,
              }
            : {}),
        });
      },
      setChronologySort: (field, direction) =>
        set({ chronologySortField: field, chronologySortDirection: direction }),
      setVisitsDisplayMode: (mode) => set({ visitsDisplayMode: mode }),
      setHiddenVisitTypeIds: (ids) => set({ hiddenVisitTypeIds: ids }),
    }),
    {
      name: "demanda-user-customization-preferences",
    }
  )
);
